import React, { Component } from 'react';
import { Tools } from '../utils/tools';

class TopProcessComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            platform: Tools.platformDevice()
        }
    }

    // componentDidMount() {
    // }

    onClickShowMenu = e => {
        e.preventDefault();

        let _sidebarDashboard = document.getElementById('sidebar-dashboard');
        _sidebarDashboard.style.left = '0';
    }
    
    render() {
        const {
            porcent
        } = this.props;

        const {
            platform
        } = this.state;

        return (
            <>
            <div className="row align-items-center top-process pt-3 pb-3">
                {
                    (platform === 'mobile')
                    ?
                    <div className="col-sm-12" style={{textAlign: 'right'}}>
                        <button onClick={this.onClickShowMenu}><i className="fa fa-bars" aria-hidden="true"></i></button>
                    </div>
                    :
                    <></>
                }
                <div className="col-sm-12 col-md-6">
                    <small><strong>Estás más cerca de alcanzar tus objetivos.</strong></small>
                </div>
                <div className="col-sm-12 col-md-6">
                    <div className="row justify-content-between process">
                        <div className="col-sm-6"><span className="porcent-process"><strong>{ porcent }% Terminado</strong></span></div>
                        <div className="col-sm-6"><small className="time-process"><strong><i className="fa fa-clock-o" aria-hidden="true"></i> 5min</strong></small></div>
                        <div className="col-sm-12">
                            <div className="bar-process">
                                <div className="point one"></div>
                                <div className="point two"></div>
                                <div className="point three"></div>
                                <div className="point four"></div>
                                <div className="thumb" style={{width: 'calc(' + porcent + '% + 5px)'}}></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </>
        );
    }
}

export default TopProcessComponent;